import backgroundStyle from './backgroundStyle';

const registerStyle = (...props) => ({
	...backgroundStyle(...props),
	wrapper: {
		position: 'relative',
		backgroundSize: 'cover',
		minHeight: '100vh',
		'& > div': {
			margin: 'auto',
		},
	},
});

export default registerStyle;
